/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { paginatedContactsResponseDtoSchema } from "../paginatedContactsResponseDtoSchema";
import { z } from "zod/v4";

export const listContactsQueryParamsSchema = z.object({
    "pageNumber": z.coerce.number().min(1).default(1),
"pageSize": z.coerce.number().min(1).max(100).default(25),
"search": z.optional(z.string().describe("Simple case-insensitive search over names, company, title and email value")),
"isMonitoring": z.optional(z.boolean().describe("Filter by whether the contact is monitored (synced to Radar)")),
"sources": z.optional(z.array(z.enum(["signals_bound", "user_provided"])).describe("Filter to contacts having any of the given provenance tags")),
"sortBy": z.optional(z.enum(["updatedAt", "fullName", "firstName", "lastName", "preferredName", "email", "latestLeadSignalsAt"])),
"sortOrder": z.optional(z.enum(["asc", "desc"]))
    })

export const listContactsHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Paginated contacts list
 */
export const listContacts200Schema = z.lazy(() => paginatedContactsResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const listContacts401Schema = z.any()

export const listContactsQueryResponseSchema = z.lazy(() => listContacts200Schema)